import React, { useState, useEffect } from 'react'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

import StyledTable from '../../components/ReactTable/StyledTable'
import StyledTableContainer from '../../components/StyledTableContainer/StyledTableContainer'
import StyledEmptyHeader from '../../components/StyledEmptyHeader/StyledEmptyHeader'
import idleTimeReasonService from '../../service/ideTimeReason.service'
import IdleTimeReasonModal from './AddIdleTimeReasonModal'

const IdleTimeReasonTable = () => {
  const [reasons, setReasons] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isAddReasonModalOpen, setIsAddReasonModalOpen] = useState(false)
  const [refetchCount, setRefetchCount] = useState(1)

  useEffect(() => {
    const fetchReasons = async () => {
      setIsLoading(true)
      try {
        const response = await idleTimeReasonService.getIdleTimeReasons()
        setReasons(
          Array.isArray(response.data)
            ? response.data.map((item, index) => ({ ...item, id: index + 1 }))
            : []
        )
      } catch (error) {
        console.error('Error fetching idle time reasons:', error)
        setReasons([])
      } finally {
        setIsLoading(false)
      }
    }
    fetchReasons()
  }, [refetchCount])

  const onSaveIdleTimeReasonsSuccess = () => {
    setRefetchCount((prev) => prev + 1)
  }

  const reasonsTableColumns = [
    { Header: 'ID' , accessor: 'id' },
    { Header: 'Reason', accessor: 'idleReason' },
    {
      Header: 'Color',
      accessor: 'color',
      Cell: ({ value }) => (
        <div
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '4px',
            backgroundColor: value,
            border: '1px solid #ddd',
            margin: '0 auto'
          }}
        ></div>
      )
    }
  ]

  return (
    <>
      <Stack
        sx={{
          position: 'sticky',
          top: 0,
          width: '100%',
          flexDirection: 'column',
          gap: '12px',
          borderBottom: '1px solid #eeeeee',
          backgroundColor: '#fff',
          padding: '12px 16px',
          zIndex: 100
        }}
      >
        <Stack sx={{ flexDirection: 'row', gap: '16px' }}>
          <Button
            sx={{ textTransform: 'none', color: '#fff' }}
            variant="contained"
            onClick={() => setIsAddReasonModalOpen(true)}
          >
            Add reasons
          </Button>
        </Stack>
      </Stack>

      <StyledTableContainer>
        {isLoading && <StyledEmptyHeader>Loading...</StyledEmptyHeader>}
        {!isLoading && reasons.length === 0 && (
          <StyledEmptyHeader>No idle time reasons found</StyledEmptyHeader>
        )}
        {!isLoading && reasons.length > 0 && (
          <StyledTable
            pagination={false}
            columns={reasonsTableColumns}
            data={reasons}
            hiddenColumns={[]}
          />
        )}
      </StyledTableContainer>

      {isAddReasonModalOpen && (
        <IdleTimeReasonModal
          closeHandler={() => setIsAddReasonModalOpen(false)}
          isModalOpen={isAddReasonModalOpen}
          onSaveSuccess={onSaveIdleTimeReasonsSuccess}
        />
      )}
    </>
  )
}

export default IdleTimeReasonTable
